import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import usePusher from '@/hooks/usePusher.js';
import usePresenceId from '@/components/presenceHandler/usePresenceId.js';
import Avatar from './Avatar.jsx';

const PresenceHandler = () => {
  const client = usePusher();
  const presenceId = usePresenceId();

  const members = useSelector((state) => state.presence.members);
  const mappedMembers = useMemo(() => Object.entries(members).map(([id, info]) => ({ id, ...info })), [members]);

  useEffect(() => {
    if (typeof client?.subscribe === 'undefined' || !presenceId) {
      return;
    }

    const channelName = `presence-${presenceId}`;
    client.subscribeToPresence(channelName);

    return () => client.unsubscribe(channelName);
  }, [presenceId, client]);

  if (mappedMembers?.length <= 1 || !presenceId) {
    return null;
  }

  return (
    <div className="presence-container">
      {mappedMembers.slice(0, 5).map((member, index) => (
        <Avatar //
          key={member.id}
          className={member.isCurrentUser ? 'animated current-user' : 'animated'}
          id={member.id}
          name={member.name}
          email={member.email}
          isCurrent={member.isCurrentUser}
          zIndex={mappedMembers.length + index}
        />
      ))}
      {mappedMembers.length > 5 && (
        <Avatar //
          overrideBackgroundColor="lightgrey"
          overrideContent={`+${mappedMembers.length - 5}`}
          title={`+ ${mappedMembers.length - 5} other users`}
          zIndex={10}
        />
      )}
    </div>
  );
};

export default PresenceHandler;
